import type { XYChartToolbarProps } from '../types/xy-chart.js';

export const Toolbar = (props: XYChartToolbarProps) => null;

Toolbar['displayName'] = 'XYChartChart.Toolbar';
